export const faqs = [
  {
    question: '我刚刚结婚两个月，为什么感觉婚姻生活和我想象的完全不一样？',
    answer: '这种感觉非常正常！几乎每一对新婚夫妻都会经历从"恋爱模式"到"婚姻模式"的过渡期。恋爱时你们展示的是彼此最好的一面，而婚姻则是24小时的"全貌展示"。给自己和对方3-6个月的适应期，不要急于给婚姻下结论。建议你和丈夫开诚布公地聊一聊彼此的感受，很多时候你会发现他也有类似的困惑。',
  },
  {
    question: '婚后怎么处理婆媳关系？婆婆总是干涉我们的小家庭生活。',
    answer: '婆媳关系的核心是"边界"——不是筑墙，而是建立健康的互动规则。建议分三步走：第一，和丈夫达成共识，由他作为主要沟通桥梁；第二，在尊重的前提下，温和但坚定地表达你们小家庭的自主权；第三，主动创造一些和婆婆"一对一"的温馨相处时刻，让她感受到被尊重的同时也看到你们已经是一个独立的家庭。',
  },
  {
    question: '婚后发现丈夫的消费习惯让我不太放心，该怎么沟通？',
    answer: '财务问题建议在新婚第一周就进行"财务坦白局"。如果已经错过了这个时机，现在开始也不晚。用共同目标作为开场："我在想我们一年后想去日本旅行，不如我们一起看看现在的收支情况制定一个储蓄计划？"这样比直接批评对方的消费习惯更容易被接受。',
  },
  {
    question: '结婚后感觉自己的自由时间变少了，有点焦虑，怎么办？',
    answer: '这是很多新婚女性的共同感受。婚后时间确实需要更多地分配给家庭，但不代表你要完全放弃"属于自己的时间"。建议和丈夫商量，每周固定半天作为你的"独处时间"——看书、健身、和朋友约会都可以。一个快乐的你，才能营造快乐的婚姻。',
  },
  {
    question: '我们吵架越来越频繁了，是不是婚姻出了问题？',
    answer: '吵架本身不是问题，关键是吵架之后如何修复。适度的冲突是亲密关系的正常组成部分。关注三个指标：吵架的频率是否在增加、吵架后是否能有效修复、是否在重复为同一件事争吵。如果频率在增加且无法修复，建议寻求专业的婚姻咨询。如果每次吵完能和好且从中有所收获，那反而是感情在加深的信号。',
  },
  {
    question: '婚后如何保持自己的独立魅力？',
    answer: '保持独立魅力的核心是"持续成长"。关注六个投资方向：职业能力、社交圈、身体健康、深度爱好、阅读思考、独处能力。当你对自己满意时，你散发出的自信光芒自然吸引人。记住，婚后保持魅力不是为了取悦丈夫，而是为了取悦自己。',
  },
  {
    question: '什么时候该考虑要孩子？婚后多久比较合适？',
    answer: '没有一个"标准时间"，关键在于你们是否做好了三个准备：情感准备（婚姻是否稳定、育儿观念是否一致）、经济准备（是否有足够的储蓄和稳定的收入来支撑育儿开销）、职业准备（双方的工作安排是否能适应育儿的需求）。一般建议婚后至少享受1-2年的二人世界，充分磨合之后再考虑要孩子。',
  },
  {
    question: '夫妻之间如何分配家务才最公平？',
    answer: '公平的家务分工不一定是"五五分"，而是"双方都觉得合理"。建议三步走：先做一次完整的家务盘点，然后根据各自的擅长和偏好分工（而非性别），最后对双方都不喜欢的家务采用轮流制。最重要的是——当对方做了家务，无论做得如何，先说感谢。',
  },
];

export const testimonials = [
  {
    name: '丽华',
    text: '刚结婚的时候真的手足无措，还好有这个人妻指南帮助我度过了最难的新婚第一年。特别是关于婆媳相处的那篇文章，让我和婆婆的关系有了质的改变。',
    role: '已婚2年',
  },
  {
    name: '美琪',
    text: '我和老公的沟通一直有问题，看完"5种爱的语言"那篇文章后才明白，我们一直在用不同的方式表达爱意。现在我们的关系比恋爱时还要好！',
    role: '已婚1年',
  },
  {
    name: '晓雯',
    text: '婚后我曾经因为失去自我而感到迷茫。这个网站让我明白，做一个好妻子和做自己并不矛盾。强烈推荐给每一位新婚姐妹。',
    role: '已婚3年',
  },
  {
    name: '诗涵',
    text: '从单身到人妻的转变真的需要很多智慧。感谢这些温暖又实用的文章陪我走过了婚后最迷茫的那段时光。',
    role: '已婚半年',
  },
];

export const aboutContent = {
  brandName: '第一次人妻完全指南',
  tagline: '陪伴每一位初为人妻的你，从容迎接人生新阶段',
  introduction:
    '我们是一群经历过新婚迷茫期的妻子和专业的婚姻咨询师，深知从"女孩"到"妻子"的身份转变中，有多少不为人知的困惑和挑战。于是我们创办了这个平台，用温暖、专业、接地气的内容，陪伴每一位新婚女性走过这段珍贵而微妙的旅程。',
  mission:
    '我们的使命是帮助每一位初为人妻的女性建立健康的婚姻观念，掌握实用的婚姻经营技巧，在婚姻中找到自我与共同体的平衡，成为幸福自信的现代妻子。',
  story:
    '这个网站的创始人在自己新婚第一年时，发现市面上的婚姻建议要么过于理论化，要么充斥着"女人就该怎样怎样"的传统说教。她希望创建一个真正站在新婚女性角度、提供实用建议的温暖空间。于是，第一次人妻完全指南诞生了。',
  contact: {
    email: 'hello@firstwife.guide',
    wechat: 'firstwife_guide',
    address: '上海市浦东新区',
  },
};